import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { ProductItemProductFragmentDoc } from './ProductItemProduct.generated'
import * as Types from './purchasePlus_graphql'

export const TileProductInfoProductFragmentDoc = gql`
  fragment TileProductInfoProduct on ProductInterface {
    id
    image
    ...ProductItemProduct
  }
  ${ProductItemProductFragmentDoc}
` as unknown as DocumentNode<Types.TileProductInfoProductFragment, unknown>
